import React, { Component } from 'react';
import { Chip, Dialog, DialogContent, Divider, Slide, Tooltip } from "@material-ui/core/";
import CloseIcon from '@material-ui/icons/Close';
import { Button, IconButton } from "@material-ui/core";
import strings from "../localization";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import SelectControl from '../components/controls/SelectControl';
import { getDocumentTypes, hasDocumentType, getFilesMissingDocumentType } from '../constants/DocumentType';
import { changeFileType } from '../services/FileUpload';

const ERROR_SELECT_STYLES = {
    control: (base) => ({
        ...base,
        borderColor: '#f44336',
        boxShadow: '0 0 0 1px #f44336',
        '&:hover': {
            borderColor: '#f44336'
        }
    })
};

class FileUploadModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            files: this.props.uploadedFile ? this.props.uploadedFile : [],
            showDocumentTypeErrors: false
        }

        this.onChange = this.onChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDone = this.onDone.bind(this);
    }

    Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="left" ref={ref} {...props} />;
    });

    filesSignature(files) {
        if (!files || files.length === 0) {
            return '';
        }

        return files.map(file => {
            if (!file) {
                return '';
            }

            const documentType = file.documentType != null ? file.documentType : file.DocumentType;
            const typeValue = typeof documentType === 'object' && documentType
                ? (documentType.value != null ? documentType.value : documentType.Value)
                : documentType;

            return `${file.id}:${typeValue != null ? typeValue : 0}:${file.isPending ? 1 : 0}`;
        }).join('|');
    }

    componentWillReceiveProps(props) {
        if (this.filesSignature(props.uploadedFile) === this.filesSignature(this.state.files)) {
            return;
        }

        this.setState({
            files: props.uploadedFile ? props.uploadedFile : []
        });
    }

    componentDidUpdate(prevProps) {
        if (this.filesSignature(prevProps.uploadedFile) === this.filesSignature(this.props.uploadedFile)) {
            return;
        }

        if (this.filesSignature(this.props.uploadedFile) === this.filesSignature(this.state.files)) {
            return;
        }

        this.setState({
            files: this.props.uploadedFile ? this.props.uploadedFile : []
        });
    }

    findFile(id) {
        for (let file of this.state.files) {
            if (file.id == id) {
                return file;
            }
        }

        return null;
    }

    closeModal(discardPending = true) {
        this.setState({
            showDocumentTypeErrors: false
        });

        if (discardPending && this.props.onDiscardPendingFiles) {
            this.props.onDiscardPendingFiles();
        }

        if (this.props.toggleModal) {
            this.props.toggleModal();
        }
    }

    onDone() {
        const missing = getFilesMissingDocumentType(this.state.files);

        if (missing.length > 0) {
            this.setState({
                showDocumentTypeErrors: true
            });
            return;
        }

        this.closeModal(false);
    }

    onChange(event, id) {
        let file = this.findFile(id);

        if (!file) {
            return;
        }

        let index = this.state.files.indexOf(file);

        if (index < 0) {
            return;
        }

        const selectedType = event.target.value;

        if (file.isPending) {
            if (this.props.onCommitPendingFile) {
                this.props.onCommitPendingFile(file, selectedType);
            }
            return;
        }

        changeFileType(id, selectedType.value).then(response => {
            if (!response || !response.ok) {
                return;
            }

            let files = this.state.files;
            files[index].documentType = selectedType;

            const stillMissing = getFilesMissingDocumentType(files);

            this.setState({
                files: files,
                showDocumentTypeErrors: stillMissing.length > 0 ? this.state.showDocumentTypeErrors : false
            });
        });
    }

    renderFiles(files) {
        let result = [];
        let options = getDocumentTypes(this.props.uploadSection);

        for (let file of files) {
            let shortName = file ? file.name : '';

            if (shortName.length > 22) {
                shortName = shortName.substring(0, 22) + '...';
            }

            const missingType = this.state.showDocumentTypeErrors && !hasDocumentType(file);

            result.push(
                <div key={file.id} className={'uploaded-file-item'}>
                    <div className={'uploaded-file-chip'}>
                        <Tooltip title={file ? file.name : ''}>
                            <Chip
                                icon={<AttachFileIcon />}
                                label={shortName}
                                clickable
                                color="success"
                                className={'chip-uploaded-file'}
                            />
                        </Tooltip>

                        {options && options.length > 0 &&
                            <SelectControl
                                placeholder={strings.documents.documentType}
                                fullWidth
                                autoFocus
                                name={'documentType-' + file.id}
                                onChange={(event) => this.onChange(event, file.id)}
                                margin="normal"
                                options={options}
                                nameKey={'name'}
                                valueKey={'value'}
                                selected={file.documentType}
                                isSearchable={false}
                                styles={missingType ? ERROR_SELECT_STYLES : undefined}
                            />
                        }
                    </div>
                    {missingType &&
                        <p className={'document-type-select-error'}>
                            {strings.documents.documentTypeRequired}
                        </p>
                    }
                </div>
            );
        }

        return result;
    }

    render() {
        return (
            <Dialog
                onClose={() => this.closeModal(true)}
                aria-labelledby="customized-dialog-title"
                open={this.props.open}
                TransitionComponent={this.Transition}
                className={'form-modal'}
            >
                <div className='form-modal-header'>
                    <div>
                        <h1>{this.props.title}</h1>
                        <IconButton className={'close-button-wrapper'} onClick={() => this.closeModal(true)}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <Divider />
                </div>
                <DialogContent dividers>
                    {this.props.content}
                </DialogContent>
                <Divider />
                <div className={'browse-button'}>
                    <Button variant="contained" color="primary" onClick={this.props.openDialog}>
                        {strings.documents.browse}
                    </Button>
                </div>
                <h3 className={'file-upload-modal-h3'}>{strings.documents.myAttachments}</h3>
                <Divider />
                {
                    this.state.files ?
                        Object.keys(this.state.files).length > 0 &&
                        <div className={'uploaded-files-chip-wrapper'}>
                            {this.renderFiles(this.state.files)}
                        </div>
                        :
                        ''
                }
                <div className={'done-button'}>
                    <Button variant="contained" color="primary" onClick={this.onDone}>
                        {strings.documents.done}
                    </Button>
                </div>
            </Dialog>
        );
    }
}

export default FileUploadModal;
